<template>
    <div class="authentication_form_box safe-distance-top">
        <div class="scholar_top">
            <van-icon
                style="position: absolute; left: 10px"
                size="25"
                name="arrow-left"
                @click="to()"
            />
            <h3 class="my">机构认证</h3>
        </div>
        <div class="scholar_bottom">
            <p class="group_title">基本信息</p>
            <van-cell-group class="cell_group_box">
                <van-cell class="upload_box" :required="true" title="头像" center>
                    <template>
                        <van-image
                            class="upload_img"
                            round
                            width="37px"
                            height="37px"
                            :src="
                                organization.logo
                                    ? $global.imgUrl + organization.logo
                                    : require('@/assets/img/mobile-img/upload-default.png')
                            "
                            @click="preview(organization.logo)"
                        />
                        <van-uploader
                            :max-size="1 * 1024 * 1024"
                            :before-read="beforeRead"
                            :after-read="(file) => clzpAfterRead(file, 'logo')"
                            @oversize="onOversize"
                        >
                            <van-icon class="upload_icon" name="arrow" />
                        </van-uploader>
                    </template>
                </van-cell>
                <van-cell
                    :required="true"
                    title="机构名称"
                    :value="organization.orgName | isNull"
                    @click="
                        toEdit('inputEdit', {
                            objName: 'organization',
                            key: 'orgName',
                            label: '机构名称',
                            ruleKey: 'name',
                        })
                    "
                    is-link
                />
                <van-cell
                    title="营业执照"
                    :value="organization.businessLicense | isImgNull"
                    @click="
                        toEdit('ImgEdit', {
                            objName: 'organization',
                            key: 'businessLicense',
                            label: '营业执照',
                        })
                    "
                    is-link
                />
                <van-cell
                    :required="true"
                    title="社会统一代码"
                    :value="organization.socialUnifiedCode | isNull"
                    @click="
                        toEdit('inputEdit', {
                            objName: 'organization',
                            key: 'socialUnifiedCode',
                            label: '社会统一代码',
                            ruleKey: 'required',
                        })
                    "
                    is-link
                />
            </van-cell-group>
            <p class="group_title" style="margin: 22px 0px 0px 0px">账号管理员信息</p>
            <van-cell-group class="cell_group_box">
                <van-cell
                    :required="true"
                    title="姓名"
                    :value="organization.adminUserName | isNull"
                    @click="
                        toEdit('inputEdit', {
                            objName: 'organization',
                            key: 'adminUserName',
                            label: '姓名',
                            ruleKey: 'adminUserName',
                        })
                    "
                    is-link
                />
                <van-cell
                    :required="true"
                    title="身份证号"
                    :value="organization.idNumber | isNull"
                    @click="
                        toEdit('inputEdit', {
                            objName: 'organization',
                            key: 'idNumber',
                            label: '身份证号',
                            ruleKey: 'idNumber',
                        })
                    "
                    is-link
                />
                <van-cell
                    :required="true"
                    title="上传身份证照片"
                    :value="organization.identityCardFront | isImgNull"
                    @click="
                        toEdit('ImgEdit', {
                            objName: 'organization',
                            key: 'identityCardFront,idNumberBack',
                            label: '身份证',
                        })
                    "
                    is-link
                />
            </van-cell-group>
        </div>
        <div class="submit_btn">
            <van-button
                class="form_btn"
                round
                block
                type="info"
                native-type="submit"
                :loading="submitLoding"
                @click="submitFn"
                >提交</van-button
            >
        </div>
    </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
export default {
    data() {
        return {
            organization: {
                logo: "",
                orgName: "",
                businessLicense: "",
                socialUnifiedCode: "",
                adminUserName: "",
                idNumber: "",
                identityCardFront: "",
                idNumberBack: "",
            },
            submitLoding: false,
        };
    },
    filters: {
        isNull(value) {
            return value !== "" && value !== "-" ? value : "未设置";
        },
        isImgNull(value) {
            return value !== "" ? "已上传" : "未设置";
        },
    },
    async created() {
        if (sessionStorage.getItem("organization")) {
            let organization = JSON.parse(sessionStorage.getItem("organization"));
            for (const key in organization) {
                this.organization[key] = organization[key];
            }
        } else {
            let res = await this.$apis.userServe.getOrganizationCertificationDetail();
            let organization = res.data.data.jsonDataObj;
            console.log(organization, "organization");
            for (const key in organization) {
                this.organization[key] = organization[key];
            }
            console.log(res, "res");
        }
    },
    watch: {
        organization: {
            handler(newV) {
                sessionStorage.setItem("organization", JSON.stringify(newV));
            },
            deep: true,
        },
    },
    methods: {
        to() {
            if (this.$route.query.out) {
                // 有out代表是APP进入
                if (this.$global.isAndroid_ios()) {
                    window.android.gubeit();
                } else {
                    window.webkit.messageHandlers.gubeit.postMessage("null"); //ios
                }
                return;
            }
            window.history.go(-1);
            sessionStorage.removeItem("organization");
        },
        //校验图片的格式
        beforeRead(file) {
            if (!/(jpg|jpeg|png|JPG|PNG)/i.test(file.type)) {
                Toast("仅支持JPG、JPEG、PNG格式");
                return false;
            }
            return true;
        },
        //校验上传图片大小
        onOversize(file) {
            Toast("文件大小不能超过1MB");
        },
        // 预览上传的图片
        preview(url) {
            if (url) {
                ImagePreview({
                    images: [this.$global.imgUrl + url],
                    closeable: true,
                });
            }
        },
        //照片上传事件方法
        async clzpAfterRead(file, key) {
            // 创建一个空对象实例
            let formData = new FormData();
            // 调用append()方法添加数据
            formData.append("file", file.file);
            const res = await this.$apis.myServe.uploadFileMannual(formData);
            this.organization[key] = res.data;
        },
        // 去编辑
        toEdit(path, query) {
            console.log(path, query);
            this.$router.push({ path, query });
        },
        // 提交
        async submitFn() {
            this.submitLoding = true;
            let dataObj = {
                logo: "头像",
                orgName: "机构名称",
                businessLicense: "营业执照",
                socialUnifiedCode: "社会统一代码",
                adminUserName: "姓名",
                idNumber: "身份证号",
                identityCardFront: "身份证人像面",
                idNumberBack: "身份证国徽面",
            };
            for (let key in this.organization) {
                let value = this.organization[key];
                if (!value) {
                    Toast(`${dataObj[key]}不能为空`);
                    return;
                }
            }
            let res = await this.$apis.userServe.organizationCertification(this.organization);
            if (res.data.resultCode === "200") {
                Toast("提交成功");
                this.$router.push({ path: "scholarStatus", query: { title: "机构认证" } });
                sessionStorage.removeItem("organization");
            } else {
                Toast(res.data.resultDesc);
            }
            this.submitLoding = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.authentication_form_box {
    width: 100vw;
    min-height: 100vh;
    overflow: hidden;
    background: #f5f5f5;

    .scholar_top {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 44px;
        line-height: 44px;
        background: #fff;
    }

    .my {
        font-size: 18px;
        color: #333333;
    }

    .submit-btn-1 {
        padding: 0px 10px !important;
        background-color: #4a79f1;
        border-radius: 5px;
        color: #fff;
        font-size: 13px !important;
        height: 25px;
        line-height: 25px;
        position: absolute;
        right: 10px;
    }

    .scholar_bottom {
        margin: 22px auto;
        padding-bottom: 20px;
        width: 94%;
        height: 100%;

        .group_title {
            font-size: 14px;
            color: #999999;
            line-height: 20px;
        }

        .cell_group_box {
            margin-top: 12px;
            border-radius: 8px;
            overflow: hidden;

            .upload_box {
                .upload_img {
                    margin-right: 10px;
                    vertical-align: middle;
                }

                .upload_img_card {
                    border-radius: 5px;
                    overflow: hidden;
                }

                .upload_icon {
                    height: 24px;
                    font-size: 16px;
                    line-height: 24px;
                    color: #969799;
                    vertical-align: middle;
                }
            }

            .list_cell {
                .list_btn {
                    font-size: 14px;
                    color: #4a79f1;
                    line-height: 14px;
                }
            }
        }
    }

    .submit_btn {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        padding: 5px 15px 0;
        padding-bottom: calc(constant(safe-area-inset-bottom) + 10px) !important;
        padding-bottom: calc(env(safe-area-inset-bottom) + 10px) !important;
        background-color: #fff;

        .form_btn {
            width: 100%;
            height: 44px;
            background: #4a79f1;
            border-radius: 22px;
        }
    }
}
</style>
